"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_jss_1 = require("react-jss");
var theme_1 = require("../../../mantine-theme/src");
exports.default = react_jss_1.createUseStyles({
    paper: function (_a) {
        var theme = _a.theme, radius = _a.radius, shadow = _a.shadow, padding = _a.padding;
        return ({
            backgroundColor: theme.colorScheme === 'dark' ? theme.colors.dark[7] : theme.white,
            boxSizing: 'border-box',
            borderRadius: theme_1.getSizeValue({ size: radius, sizes: theme.radius }),
            boxShadow: theme.shadows[shadow] || shadow || 'none',
            padding: theme_1.getSizeValue({ size: padding, sizes: theme.spacing }),
        });
    },
}, { link: true });
